import { CreditNoteServicePeriod } from 'CreditNotes/types'
import { useCreditNoteQuery } from './useCreditNote'
import { startOfMonth, endOfMonth } from 'date-fns'
import { formatISODate } from '@sequencehq/utils'

export const useCreditNoteDefaultServicePeriod = (
  creditNoteId: string
): CreditNoteServicePeriod => {
  const { data: creditNote } = useCreditNoteQuery(creditNoteId)

  const fallbackStart = formatISODate(startOfMonth(new Date()))
  const fallbackEnd = formatISODate(endOfMonth(new Date()))

  return {
    start: creditNote?.billingPeriodStart ?? fallbackStart,
    endInclusive: creditNote?.billingPeriodEnd ?? fallbackEnd
  }
}
